import { BaseFieldView } from '../BaseField/views';
import { NA } from '../constants';

export const YesNoFieldHistoryListItem = Backbone.Marionette.ItemView.extend({
    template: '#tpl_yesno_field_history_list_item',
    model: null, // YesNoHistoryItem
    className: 'yesno_history_item',

    templateHelpers: function () {
        var value = this.model.get('acceptance_value') || this.model.get('value');
        if (value === true || value === 1) {
            var icon = 'df-success';
        } else if (value === false || value === -1) {
            icon = 'df-close';
        } else if (value === NA || value === 0) {
            // this currently triggers text rather than icon
            icon = NA;
        } else {
            icon = 'df-unavailable';
        }

        return {
            icon: icon
        };
    }
});

export const YesNoFieldHistoryList = Backbone.Marionette.CollectionView.extend({
    template: '#tpl_yesno_field_history_list',
    itemView: YesNoFieldHistoryListItem,
    className: 'yesno_history',

    collection: null, // YesNoHistoryItemList

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    }
});

export const YesNoFieldView = BaseFieldView.extend({
    regions: {
        r_yesno_history: '.yesno_history_container'
    },

    events: {
        'click .yesno_buttons .btn': 'save_value'
    },

    templateHelpers: function () {
        return $.extend(YesNoFieldView.__super__.templateHelpers.apply(this, arguments), {
            // @jira:MOBILE-360 previous submissions are currently being sent back from ElasticSearch,
            // which does not store metadata. For now, we're just showing the N/A button if that's the actual
            // value of the model, but this will be unnecessary once we update this to draw from Mongo.
            show_na_btn:
                (this.model.get('metadata') && this.model.get('metadata').allow_na) || this.model.get('value') === NA
        });
    },

    initialize: function () {
        var this_ = this;
        YesNoFieldView.__super__.initialize.apply(this, arguments);

        var account_field = this.model.collection.findWhere({ type: 'account' });

        if (!account_field) {
            return;
        }

        // @author:david @jira:MOBILE-572 whenever the location field changes, we need to recalculate our yes/no history.
        // But, this could be a lot of requests at once if there are a lot of "no" fields already answered.
        this.listenTo(account_field, 'change:value', function () {
            this_.toggle_yesno_history();
        });
    },

    onRender: function () {
        if (this.model.get('value') !== '') {
            // Highlight the appropriate yes/no button if set. Look for an acceptance_value first.
            var selected_class;
            var acceptance_value = this.model.get('acceptance_value');
            switch (acceptance_value) {
                case 1:
                    selected_class = 'selected_pass';
                    break;
                case -1:
                    selected_class = 'selected_failure';
                    break;
                default:
                    selected_class = 'selected';
            }
            const modelValue = this.model.get('value');

            if (!$f.utils.is_nil(modelValue) || modelValue === '') {
                this.$el.find(`.yesno_buttons .btn[value=${modelValue}]`).addClass(selected_class);
            }
        }

        this.toggle_yesno_history();
    },

    /**
     * Scroll down to the next element after this is changed.
     **/
    on_change_action: function () {
        this._scroll_down_one_field();
    },

    save_value: function (event) {
        const modelValue = this.model.get('value');

        // are they clicking the same thing again
        if (modelValue?.toString() == $(event.target).attr('value')) {
            this.model.set({ value: '' }); // dont unset, as default is empty string
            $(event.target).removeClass('selected');
            return false;
        }

        var val = $(event.target).attr('value');

        // if 'true' or 'false', save as true or false. Otherwise 'na' or '' is fine.
        try {
            val = JSON.parse(val);
        } catch (e) {
            /* noop */
        }

        this.model.set({ value: val });
        return false;
    },

    /**
     * Display historical answers for this field.
     */
    toggle_yesno_history: function () {
        var this_ = this;
        var collection = this.model.collection;
        var account_field = collection.findWhere({ type: 'account' });

        if (!collection.metadata.get('is_show_yesno_history')) {
            return this.r_yesno_history.close();
        }

        // Only show if our value is "failure", if we don't have the acceptance_value, then assume false is a failure.
        //    and there is an account field chosen
        var is_failure =
            (this.model.get('acceptance_value') && this.model.get('acceptance_value') === -1) ||
            (!this.model.get('acceptance_value') && this.model.get('value') === false);

        if (!is_failure || !account_field || !account_field.get('value')) {
            return this.r_yesno_history.close();
        }

        this.model.get_history(function (history_items) {
            if (!history_items || !history_items.length || !this_.r_yesno_history) {
                return;
            }

            this_.r_yesno_history.show(
                new YesNoFieldHistoryList({
                    collection: history_items
                })
            );
        });
    }
});
